import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 250px;
`;

export const RadioGroup = styled.div`
	padding-top: 16px;
`;

export const RadioWrapper = styled.div`
	padding: 6px 0px;

	span + span {
		font-weight: normal;
		font-size: 16px;
		line-height: 24px;
		color: ${colors.grey8};
		padding-left: 16px !important;
		overflow: hidden;

		${({ disabled }) =>
			disabled &&
			css`
				color: ${colors.grey5};
				cursor: default;
			`};
	}
`;

export const RadioLabel = styled.div`
	display: flex;
	width: 100%;
	white-space: nowrap;

	span {
		font-weight: 500;
	}
`;

export const HelperText = styled.div`
	display: flex;
	padding-left: 16px;
	font-size: 13px;
	line-height: 24px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	overflow: hidden;
	white-space: nowrap;
`;

export const TextTruncate = styled.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const Subtitle = styled.div`
	font-size: 16px;
	line-height: 20px;
	color: ${colors.amber};
	padding: 8px 0 16px 0;
`;

export const LoaderWrapper = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;
